import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ca2be7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "result-card" }
const _hoisted_2 = {
  key: 0,
  class: "partners-icon"
}
const _hoisted_3 = {
  key: 1,
  class: "result-card__close"
}
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = { class: "result-card__container" }
const _hoisted_6 = { class: "result-card__container-info" }
const _hoisted_7 = { class: "result-card__container-price" }
const _hoisted_8 = {
  key: 0,
  class: "result-card__container-item"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dark-text-color" }, "Ипотека от: ", -1))
const _hoisted_10 = { class: "blue-color" }
const _hoisted_11 = {
  key: 0,
  class: "result-card__container-item"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dark-text-color" }, "Дом: ", -1))
const _hoisted_13 = {
  key: 1,
  class: "result-card__container-item"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dark-text-color" }, "Этаж: ", -1))
const _hoisted_15 = { class: "mt--10 result-card__container-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dark-text-color" }, "Участок: ", -1))
const _hoisted_17 = { class: "result-card__container-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dark-text-color" }, "Тип: ", -1))
const _hoisted_19 = { class: "result-card__container-icons" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "card-container-mobile only-mobile" }
const _hoisted_23 = { class: "result-card-mobile" }
const _hoisted_24 = {
  key: 0,
  class: "partners-icon"
}
const _hoisted_25 = {
  key: 1,
  class: "result-card__close"
}
const _hoisted_26 = { class: "relative" }
const _hoisted_27 = {
  key: 0,
  class: "partners-icon"
}
const _hoisted_28 = { class: "result-card-mobile__container" }
const _hoisted_29 = { class: "items-in-column gap--0 result-card-mobile__container-price" }
const _hoisted_30 = { class: "medium" }
const _hoisted_31 = {
  key: 0,
  class: "result-card-mobile__container-payment"
}
const _hoisted_32 = {
  key: 0,
  class: "result-card-mobile__container-item"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "third-color" }, "Дом", -1))
const _hoisted_34 = { class: "items-in-line" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = {
  key: 1,
  class: "result-card-mobile__container-item"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "third-color" }, "Земля", -1))
const _hoisted_39 = { class: "items-in-line" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "result-card-mobile__container-icons" }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { class: "center" }
const _hoisted_45 = ["href"]
const _hoisted_46 = ["src"]

import { ResultCardType } from '@/types';
import { CompareIcon, SaveDocsBtn } from '@/components/Cards/CardsComponents';
import { useUserStore } from '@/store/modules/user';
import { useAppStore } from '@/store/modules/app';
import { useRouter } from 'vue-router';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferSmallCard',
  props: {
    card: {},
    isActive: { type: Boolean },
    withClose: { type: Boolean },
    withoutScale: { type: Boolean }
  },
  emits: ['changeActive', 'close', 'hideActive', 'middle'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const router = useRouter();
const photos = computed((): string[] => {
  return props.card.id === props.card.landId
    ? props.card.landImgs
    : [...props.card.img, ...props.card.landImgs];
});

const changeIsFavorite = (cardId: number) => {
  if (useUserStore().user) {
    useUserStore().changeIsFavorite(cardId);
  } else {
    useAppStore().openAuthModal(true);
  }
};

const mousedownHandler = (event: MouseEvent) => {
  if (event.button === 1) {
    emit('middle');
  }
};

return (_ctx: any,_cache: any) => {
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_brazzers_carousel = _resolveComponent("base-brazzers-carousel")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_rating_number = _resolveComponent("base-rating-number")!
  const _component_base_image = _resolveComponent("base-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([[{ active: _ctx.isActive }, { scale: !_ctx.isActive && !_ctx.withClose && !_ctx.withoutScale }], "card-container none-Mobile"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.card.affiliateProgramId)
          ? (_openBlock(), _createElementBlock("button", _hoisted_2, "₽"))
          : _createCommentVNode("", true),
        (_ctx.withClose)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_base_icon, {
                clickable: "",
                "font-size": "28",
                name: "close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: { name: 'offerCard', params: { url: _ctx.card.landUrl } }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_base_brazzers_carousel, {
                alt: _ctx.card.address,
                photos: photos.value,
                title: _ctx.card.address,
                borderRadius: "",
                height: "150",
                version: "x1",
                width: "240"
              }, null, 8, ["alt", "photos", "title"])
            ]),
            _: 1
          }, 8, ["to"]),
          (!_ctx.card.isPhysics)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: { name: 'checkResult', query: { id: _ctx.card.landId } },
                class: "verifiedBtn verifiedBtn-text center"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Проверено ")
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.card.price?.toLocaleString() || '-') + " ₽ ", 1),
              (_ctx.card.rates && _ctx.card.rates[0]?.minPayment)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.card.rates[0].minPayment.toLocaleString()) + " ₽", 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              (_ctx.card.id !== _ctx.card.landId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("span", null, _toDisplayString(`${_ctx.card.houseArea || '-'} м²`), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.card.id !== _ctx.card.landId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("span", null, _toDisplayString(_ctx.card.floor || '-'), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("span", null, _toDisplayString(`${_ctx.card.landArea || '-'} сот.`), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("span", null, _toDisplayString(_ctx.card.type || '-'), 1)
              ])
            ]),
            _createVNode(_component_base_button, {
              text: _ctx.isActive ? 'Скрыть' : 'Подробнее',
              allBlockWidth: "",
              "style-type": "coloredBorder",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('changeActive', _ctx.card.id))),
              onMousedownHandler: mousedownHandler
            }, null, 8, ["text"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            (_ctx.card.rating !== undefined)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: { name: 'classification', query: { id: _ctx.card.landId } }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_rating_number, {
                      "max-rate": _ctx.card.classifier?.maxRate,
                      rating: _ctx.card.rating
                    }, null, 8, ["max-rate", "rating"])
                  ]),
                  _: 1
                }, 8, ["to"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_20)),
            _createVNode(_component_base_button, {
              class: "center",
              icon: "",
              "style-type": "border",
              withoutActive: "",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (changeIsFavorite(_ctx.card.landId)))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_base_icon, {
                  color: _unref(useUserStore)().getIsFavorite(_ctx.card.landId) ? '#EA1F1F' : '#969696',
                  "font-size": "20",
                  name: "favorite",
                  width: "22"
                }, null, 8, ["color"])
              ]),
              _: 1
            }),
            _createVNode(_unref(CompareIcon), {
              card: _ctx.card,
              "with-border": ""
            }, null, 8, ["card"]),
            _createVNode(_unref(SaveDocsBtn), {
              docs: _ctx.card.docs
            }, null, 8, ["docs"]),
            _createElementVNode("div", null, [
              _withDirectives(_createVNode(_component_base_button, {
                href: {
                name: 'offerCard',
                params: { url: _ctx.card.landUrl },
                hash: '#map',
              },
                icon: "",
                "style-type": "coloredBorder",
                withoutActive: ""
              }, {
                icon: _withCtx(() => [
                  _createElementVNode("img", {
                    src: require('@/assets/img/mainPage/icons/icon-map.png'),
                    alt: "map"
                  }, null, 8, _hoisted_21)
                ]),
                _: 1
              }, 8, ["href"]), [
                [_vShow, _ctx.card.coordinates]
              ])
            ])
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        (_ctx.card.affiliateProgramId)
          ? (_openBlock(), _createElementBlock("button", _hoisted_24, "₽"))
          : _createCommentVNode("", true),
        (_ctx.withClose)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createVNode(_component_base_icon, {
                clickable: "",
                "font-size": "28",
                name: "close",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["prevent"]))
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_26, [
          (_ctx.card.affiliateProgramId)
            ? (_openBlock(), _createElementBlock("button", _hoisted_27, "₽"))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            to: { name: 'offerCard', params: { url: _ctx.card.landUrl } }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_base_image, {
                name: String(_ctx.card.id),
                src: _ctx.card.img ? _ctx.card.img[0] : _ctx.card.landImgs[0],
                borderRadius: "",
                cover: "",
                height: "150",
                version: "x1",
                width: "100%"
              }, null, 8, ["name", "src"])
            ]),
            _: 1
          }, 8, ["to"]),
          (!_ctx.card.isPhysics)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: { name: 'checkResult', query: { id: _ctx.card.landId } },
                class: "verifiedBtn verifiedBtn-text center"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Проверено ")
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.card.price?.toLocaleString() || '-') + " ₽", 1),
              (_ctx.card.rates && _ctx.card.rates[0]?.minPayment)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("span", null, "от " + _toDisplayString(_ctx.card.rates[0].minPayment.toLocaleString()) + " ₽/мес", 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.card.houseArea || _ctx.card.floor)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("span", _hoisted_34, [
                    (_ctx.card.houseArea)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.card.houseArea) + "м² ", 1))
                      : _createCommentVNode("", true),
                    (_ctx.card.floor)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.card.floor) + " этaж", 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.card.type || _ctx.card.landArea)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("span", _hoisted_39, [
                    (_ctx.card.type)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.card.type), 1))
                      : _createCommentVNode("", true),
                    (_ctx.card.landArea)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.card.landArea) + " сот.", 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_42, [
            (_ctx.card.rating !== undefined)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: { name: 'classification', query: { id: _ctx.card.landId } }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_rating_number, {
                      "max-rate": _ctx.card.classifier?.maxRate,
                      rating: _ctx.card.rating
                    }, null, 8, ["max-rate", "rating"])
                  ]),
                  _: 1
                }, 8, ["to"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_43)),
            _createVNode(_component_base_icon, {
              color: _unref(useUserStore)().getIsFavorite(_ctx.card.landId) ? '#EA1F1F' : '#969696',
              clickable: "",
              "font-size": "24",
              name: "favorite",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (changeIsFavorite(_ctx.card.landId)), ["prevent"]))
            }, null, 8, ["color"]),
            _createVNode(_unref(CompareIcon), { card: _ctx.card }, null, 8, ["card"]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("a", {
                href: `${_ctx.card.linkUrl}#map`
              }, [
                _withDirectives(_createVNode(_component_base_icon, { clickable: "" }, {
                  icon: _withCtx(() => [
                    _createElementVNode("img", {
                      src: require('@/assets/img/mainPage/icons/icon-map.png'),
                      alt: "map"
                    }, null, 8, _hoisted_46)
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.card.coordinates]
                ])
              ], 8, _hoisted_45)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})